import styled from 'styled-components';

interface ITab {
  isActived: boolean;
  handleClick: () => void;
  name: string;
}

interface TabPillProps {
  tabInfos: ITab[];
}

export const TabPill = ({ tabInfos }: TabPillProps) => {
  return (
    <TabContainer>
      <TabBackground>
        {tabInfos.map((tab) => (
          <Tab key={tab.name} isActived={tab.isActived} onClick={tab.handleClick}>
            <TabText isActived={tab.isActived}>{tab.name}</TabText>
          </Tab>
        ))}
      </TabBackground>
    </TabContainer>
  );
};

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;

  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
`;

const TabBackground = styled.div`
  display: flex;
  padding: var(--radius-small, 4px);
  align-items: center;
  flex: 1 0 0;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const Tab = styled.button<{ isActived: boolean }>`
  height: 32px;

  display: flex;
  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  border-radius: 6px;
  ${(props) => props.isActived && 'background: var(--Light-Scheme-Monochrome-white, #fff);'};
`;

const TabText = styled.span<{ isActived: boolean }>`
  color: ${(props) => (props.isActived ? '#232429' : '#a7a9b6')};
  text-align: center;

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
